import AttributeDetail from './AttributeDetail';

export default AttributeDetail;



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/index.ts